/* eslint-disable no-dupe-else-if */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import { Form, Input, Col, Row, Button, message } from "antd";
import { HeaderWithBottomLine } from "../../Master/CpOnbordingSteps/HeaderWithBottomLine";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  getBarcodeId,
  postShipment,
} from "../../../actionsMethods/cashBookingMethods";
import axios from "axios";
import { APIs } from "../../../utils/worker";
import ChildModal from "../../BookingDetails/ChildModal";
import AccountBookingChildModel from "../AccountBookingChildModel";

const BookingDetails = ({
  currentScreen,
  screen,
  upDateAllData,
  allData,
  check,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [ModalVisible, setModalVisible] = useState(false);
  const [details, setDetails] = useState();
  const [childData, setChildData] = useState();
  const [count, setCount] = useState(0);
  const [disableNext, setDisableNext] = useState(false);

  const {
    // fetching: loading,
    result: tat,
    // error: err,
  } = useSelector(
    (state) => state?.appReducer?.getCalculaterTatChartReducer,
    shallowEqual
  );

  // const handleOpenCal = () => {
  //   return screen(0);
  // };
  // eslint-disable-next-line no-unused-vars

  useEffect(() => {
    if (allData?.child_Selected) {
      setDisableNext(true);
    }
  }, [allData?.child_Selected]);

  useEffect(() => {
    form.resetFields();
  }, [check]);

  let { service, travelBy } = allData;

  const serviceType = () => {
    let serviceType = "1";
    let data = allData;
    let selectedMode = service;
    if (selectedMode === "2") {
      serviceType = "Express";
    }
    if (selectedMode === "3") {
      serviceType = "ValuePlus";
    }
    if (selectedMode === "1") {
      serviceType = "Standard";
    }
    return serviceType;
  };

  let expDate = serviceType() + travelBy + "Date";

  var newObj = Object.keys(tat !== null ? tat?.data : "")
    .filter((key) => key?.toLocaleLowerCase() == expDate?.toLocaleLowerCase())
    .reduce(
      (newObj, currKey) => ((newObj[currKey] = tat?.data[currKey]), newObj),
      {}
    );

  let expDate1 = newObj ? Object.values(newObj).toString().split(" ")[0] : "";

  const {
    fetching: loading,
    result: data,
    error: err,
  } = useSelector(
    (state) => state?.appReducer?.getCalculaterTatChartReducer,
    shallowEqual
  );

  const handleCancel = () => {
    setModalVisible(false);
  };

  const handleSubmitModal = () => {
    setModalVisible(false);
    setDisableNext(false);
    // setChildPacketSubmitted(true);
  };

  const handleChildModal = () => {
    setModalVisible(true);
  };

  const { fetching, result, error } = useSelector(
    (state) => state.appReducer.getBarcodeIdReducer,
    shallowEqual
  );

  const postShipmentResponse = useSelector(
    (state) => state?.appReducer?.getPostShipmentReducer,
    shallowEqual
  );

  const {
    result: postShipmentResult,
    error: postError,
    fetching: postFetching,
  } = postShipmentResponse;

  // useEffect(() => {
  //   if (currentScreen === 1) {
  //     dispatch(getBarcodeId(allData?.service, userId?.userInfo?.premiseId));
  //   }
  // }, [currentScreen]);

  useEffect(() => {
    setChildData(JSON.parse(localStorage.getItem("userId")));
  }, [screen]);

  const userId = JSON.parse(localStorage.getItem("userId"));
  // let { suffixStatus } = acc || null;

  useEffect(() => {
    if (fetching == false && error == null) {
      form.setFieldsValue({
        awbNumber: result?.data?.awbNumber,
        pickupPincode: userId?.premises?.pincode,
        area: allData?.area,
        deliveryPincode: allData?.deliveryPincode,
        expectdDelivery: expDate1 || "01-04-2023",
      });

      if (result?.data?.awbNumber) {
        setCount(count + 1);
      }
    } else if (fetching == false && error !== null) {
      message.error(error.message);
    }
  }, [fetching, loading]);

  useEffect(() => {
    if (currentScreen == 1 && result?.data?.awbNumber) {
      createShipMent();
    }
  }, [currentScreen]);

  useEffect(() => {
    if (result?.data?.awbNumber && currentScreen === 1) {
      let data = {
        awbNumber: result?.data?.awbNumber,
        premiseId: userId?.userInfo?.premiseId,
        bookingType: "Account",
        userId: userId?.userInfo?.userId,
        destinationPincode: allData?.deliveryPincode,
      };
      // if (postShipmentResult === null) {
      //   dispatch(postShipment(data, userId?.userInfo?.premiseId));
      // }
    }
  }, [result?.data?.awbNumber, postShipmentResult]);

  const createShipMent = () => {
    let dd = form.getFieldValue("awbNumber");
    let userData = JSON.parse(localStorage.getItem("userinfo"));
    const headers = {
      Authorization: "Bearer " + userData.accessToken,
      "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
      "USER-ID": userId?.userInfo?.userId,
    };
    let data1 = {
      awbNumber: dd,
      premiseId: userId?.userInfo?.premiseId,
      userId: userId?.userInfo?.userId,
      destinationPincode: allData?.deliveryPincode,
      bookingType: "Account",
    };
    axios
      .post(`${APIs.baseURL}/shipment-service/v1/shipment`, data1, {
        headers: headers,
      })
      .then((response) => {
        if (response.status == 200) {
          axios
            .get(
              `${APIs.baseURL}/premise-service/v1/premise/pincode/${allData?.deliveryPincode}`,
              {
                headers: headers,
              }
            )
            .then((res) => {
              if (res.status == 200) {
                let ss = res?.data;
                let payload = { ss, data1 };
                upDateAllData(payload);
              }
            });
        }
      })
      .catch((error) => {
        message.error(error?.response?.data?.message);
      });
  };

  const onSubmitFormData = (values) => {
    let temp = {
      ...values,
    };
    upDateAllData(temp);

    screen(2);
  };

  const formProps = {
    name: "address",
    className: "register-form",
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  let fun = () => {
    const arr = [];
    Object.keys(allData).forEach(function (key) {
      if (key.search("length") === 0) {
        const sp = key.split("length");
        if (sp[1] && sp[1] !== "") {
          const wid = `width${sp[1]}`;
          const height = `height${sp[1]}`;
          const len = `length${sp[1]}`;
          const total = `total${sp[1]}`;

          const oj = {
            length: allData[len],
            width: allData[wid],
            height: allData[height],
            totalweight: allData[total],
          };
          arr.push(oj);
        }
      }
    });

    return arr;
  };
  return (
    <div style={{ padding: "51px 69px 0" }}>
      {allData?.child_Selected && result?.data?.awbNumber ? (
        <AccountBookingChildModel
          visible={ModalVisible}
          handleCancel={handleCancel}
          allData={allData}
          // childData={fun()}
          awb={result?.data?.awbNumber}
          serviceType={allData?.service}
          handleSubmitModal={handleSubmitModal}
          currentScreen={currentScreen}
          premiseId={userId?.userInfo?.premiseId}
          childDetails={fun()}
        />
      ) : null}
      <Form
        {...formProps}
        layout={"vertical"}
        form={form}
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
          inline: "center",
        }}
        className="global-form"
      >
        <HeaderWithBottomLine text={"Booking Details"} icon={false} />
        <div style={{ paddingTop: "20px" }}>
          <Row justify="space-evenly" gutter={40} className="global-form-row ">
            <Col className="form-inputs" lg={11} xs={11} md={11} xl={11}>
              <Form.Item name="pickupPincode" label="Pickup PIN code">
                <Input
                  className="accpickupPincode"
                  disabled
                  suffix={
                    <div className="green">{userId?.premises?.stateCode}</div>
                  }
                />
                {/* <Input disabled suffix={"KA"} /> */}
              </Form.Item>
              <Form.Item
                name="awbNumber"
                label="AWB No"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="Enter booking no" disabled />
              </Form.Item>
              <Form.Item
                name="expectdDelivery"
                label="Expected date of delivery"
                rules={[
                  {
                    required: true,
                    message: "",
                  },
                ]}
              >
                <Input placeholder="Enter booking no" disabled />
              </Form.Item>
            </Col>

            <Col className="form-inputs" lg={11} xs={11} md={11} xl={11}>
              <Form.Item name="deliveryPincode" label="Delivery PIN code">
                <Input
                  disabled
                  className="accpickupPincode"
                  suffix={
                    <div
                      className={
                        allData?.suffixStatus?.serviceability === "Regular"
                          ? "green"
                          : allData?.suffixStatus?.serviceability === "Premium"
                          ? "orange"
                          : "red"
                      }
                    >
                      {allData?.suffixStatus?.stateCode}
                    </div>
                  }
                />
              </Form.Item>
              <Form.Item name="area" label="Area" className="bookingAreaItem">
                <Input disabled />
              </Form.Item>
            </Col>
          </Row>
          <p style={{ textAlign: "start", paddingLeft: "30px" }}>
            {allData.child_Selected && result?.data?.awbNumber && (
              <div>
                <span
                  onClick={handleChildModal}
                  className="pointer"
                  style={{ color: " #1890ff" }}
                >
                  Click here
                </span>
                <span> {"to enter child packets number"}</span>
              </div>
            )}
          </p>

          <hr className="divider" style={{ marginTop: "20px" }} />

          <div className="d-flex flex-end mt-1">
            <Button
              htmlType="submit"
              disabled={disableNext}
              className="btn-style save-btn ml-1"
            >
              SUBMIT
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default BookingDetails;
